// Port of frontend src/features/appointments/SeriesCoachConflictNote.tsx (MEN-5428 copy).
import { Box, Typography } from '@mui/material';
import type React from 'react';
import { formatConflictDate } from './memberPreviewCalendar';

interface SeriesConflictNoteProps {
  conflictingOccurrenceStarts: string[];
  timeZone: string;
}

const SeriesConflictNote: React.FC<SeriesConflictNoteProps> = ({ conflictingOccurrenceStarts, timeZone }) => {
  const count = conflictingOccurrenceStarts.length;
  if (count === 0) return null;
  return (
    <Box
      role="note"
      aria-label="Coach conflicts"
      sx={{ bgcolor: 'info.light', border: 1, borderColor: 'info.main', borderRadius: '7px', px: 2, py: 1.5 }}
    >
      <Typography variant="body2" sx={{ color: 'info.main', fontWeight: 700 }}>
        {`Note: ${count} coach ${count === 1 ? 'conflict' : 'conflicts'} in this series`}
      </Typography>
      <Typography variant="body2">Ask your coach about rescheduling</Typography>
      <Typography variant="body2">
        {conflictingOccurrenceStarts.map((start) => formatConflictDate(start, timeZone)).join(' • ')}
      </Typography>
    </Box>
  );
};

export default SeriesConflictNote;
